export default __webpack_public_path__ + "static/espai-db7e4f6f07c9a37e9e3b4c93fa32d2e2.png";